import Svg from "./figs/Svg";

export default function ButtonBack(props) {
  return (
    <button
      {...props}
      className="fixed top-4 left-16 max-w-[45px] z-[100] mt-[1px] ml-[2px]"
    >
      <Svg iconName="back" className="w-full h-full" />
    </button>
  );
}
